module.exports = __webpack_public_path__ + "img/slide-6.a1052ca1.png";